var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSLetter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.152 9C17.1026 9 17.9264 9.13922 18.6235 9.41767C19.3332 9.68346 19.9859 10.0948 20.5816 10.6517L19.2508 12.1895C18.7819 11.8098 18.3129 11.5313 17.844 11.3541C17.3751 11.1769 16.8744 11.0883 16.3421 11.0883C15.7591 11.0883 15.2902 11.2149 14.9353 11.468C14.5931 11.7085 14.422 12.0566 14.422 12.5122C14.422 12.8286 14.4917 13.0881 14.6311 13.2906C14.7832 13.4931 15.043 13.683 15.4106 13.8602C15.7781 14.0373 16.3295 14.2399 17.0645 14.4677C18.37 14.8853 19.3459 15.4043 19.9923 16.0244C20.6386 16.632 20.9618 17.5053 20.9618 18.6444C20.9618 19.4544 20.759 20.1695 20.3535 20.7897C19.9479 21.3972 19.3586 21.8781 18.5854 22.2325C17.8123 22.5743 16.9061 22.7451 15.8668 22.7451C14.8276 22.7451 13.9024 22.5806 13.0912 22.2515C12.2801 21.9224 11.583 21.4731 11 20.9036L12.4258 19.3278C12.9328 19.7582 13.4588 20.0872 14.0038 20.315C14.5487 20.5302 15.1444 20.6378 15.7908 20.6378C16.4752 20.6378 17.0202 20.4796 17.4258 20.1632C17.844 19.8467 18.0531 19.4038 18.0531 18.8342C18.0531 18.4798 17.9771 18.1887 17.825 17.9609C17.6856 17.7204 17.4384 17.5053 17.0836 17.3154C16.7287 17.1256 16.2154 16.9294 15.5437 16.7269C14.1115 16.2839 13.0849 15.7523 12.4639 15.1321C11.8555 14.512 11.5513 13.7019 11.5513 12.7021C11.5513 11.968 11.7478 11.3225 12.1407 10.7656C12.5336 10.1961 13.0785 9.7594 13.7756 9.45564C14.4727 9.15188 15.2648 9 16.152 9Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 6.5,
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSLetter);
export default __webpack_public_path__ + "static/media/s-letter.3741324b5c639eef9aae859a93787165.svg";
export { ForwardRef as ReactComponent };